export default __webpack_public_path__ + "static/1-2-ui-design-db14d94a8c4c9ad84d969171d6e67758.gif";